import type { ComponentType, ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

export type OmniEntityKind = 'tasks' | 'saved_filters';

export interface OmniNavItem {
  key: string;
  label: string;
  path: string;
  icon?: LucideIcon;
  hint?: string;
}

export interface OmniNavSection {
  key: string;
  label?: string;
  items: OmniNavItem[];
}

export type SearchHit = {
  key: string;
  label: string;
  node: ReactNode;
  onSelect: () => void;
};

export type SearchColumn = {
  id: string;
  heading: string;
  icon: ComponentType<{ className?: string }>;
  items: SearchHit[];
};

export const GROUP_LIMIT = 8;
/** Wait for typing to settle before hitting entity search APIs. */
export const ENTITY_DEBOUNCE_MS = 400;
